<template>
  <div>
    <v-autocomplete
      :value="tag"
      :items="filterTags"
      :label="$i18n.t(label)"
      @change="changedTo"
      @click:clear="clear"
      :multiple="isMultiple"
      :loading="loading"
      :clearable="clearable"
      :rules="rules"
      :search-input.sync="filter"
      ref="select"
      autocomplete="nope"
      :no-filter="true"
    >
      <template v-slot:selection="data">
        <div v-if="isMultiple">
          <div
            style="height: 22px;"
            v-bind:style="{ backgroundColor: data.item.color}"
            class="v-chip--select v-chip v-chip--clickable v-chip--no-color theme--light v-size--default"
          >
            {{ data.item.name }}
          </div>
        </div>
        <div v-else>
          <div ripple class="height32">
            <h5 class="text-title">{{ data.item.name }}</h5>
          </div>
        </div>
      </template>
      <template v-slot:item="data">
        <v-list-item ripple>
          <v-list-item-content>
            <v-list-item-title>
              {{ data.item.name }}
              <v-icon small v-if="selected(data.item)" style="float: right"
                >mdi-check</v-icon
              >
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </template>
      <template v-slot:append-item>
        <div class="actionBox">
          <v-btn small text color="info" @click="tagClientDialog = true">
            <v-icon>mdi-plus</v-icon>
            {{ $i18n.t("Add New Tag") }}
          </v-btn>
        </div>
      </template>
    </v-autocomplete>
    <z-tag-create
      @select="selectTag"
      :showDialog="tagClientDialog"
      :kind="kind"
      @closeDialog="closeDialog"
      :showSelectBtn="true"
    ></z-tag-create>
  </div>
</template>

<script>
import { doGet } from "@/store/common/module/apis";
import Themeable from "vuetify/lib/mixins/themeable";

import { Vue, Component, Watch } from "vue-property-decorator";
import common from "@/store/common/module/common";

@Component({
  name: "TagSelect",
  props: {
    value: {
      default: false,
    },
    label: {
      default: "Tag",
    },
    clearable: {
      default: true,
    },
    rules: {
      default: () => [],
    },
    kind: {
      default: null,
    },
    multiple: {
      default: false,
    },
  },
})
export default class TagSelect extends (Vue, Themeable) {
  tag = null;
  tags = [];
  filter = "";
  tagClientDialog = false;
  isMultiple = false;

  get loading() {
    return common.loading;
  }

  closeDialog() {
    this.tagClientDialog = false;
  }

  clear() {
    this.filter = "";
    this.tag = null;
    this.$emit("input", null);
  }

  get filterTags() {
    let filterby = this.filter;
    filterby = filterby != null ? filterby.toLowerCase() : "";
    if (filterby == "") return this.tags;
    const fs = this.tags.filter(function (s) {
      return s.name && s.name.toLowerCase().indexOf(filterby) >= 0;
    });
    return fs;
  }

  async selectTag(newTag) {
    this.tagClientDialog = false;
    if (newTag != null) {
      //fetch new data for kind
      await this.onKindChange(this.kind);
      if (Array.isArray(this.tag)) {
        let found = false;
        for (let i = 0; i < this.tag.length; i++) {
          if (this.tag[i]._id === newTag._id) {
            found = true;
          }
        }
        if (!found) this.tag.push(newTag);
        this.changedTo(this.tag);
      } else {
        this.changedTo(newTag);
      }
    }
  }

  changedTo(newVal) {
    this.filter = "";
    if (!this.isMultiple) {
      if (newVal) this.tag = newVal;
      if (newVal && newVal.name) {
        this.$emit("input", newVal._id);
        return;
      }
      if (!newVal) this.$emit("input", null);
    } else {
      const response = [];

      for (let i = 0; i < newVal.length; i++) {
        response.push(newVal[i]._id);
      }

      this.$emit("input", response);
      return;
    }
  }

  @Watch("value")
  async onValueChange() {
    if (this.value == "") {
      this.tag = null;
    }
    await this.init();
  }

  @Watch("kind")
  async onKindChange(val) {
    const url = `/api/tag/kind/${val}`;
    this.tags = await doGet(url);
    await this.init();
  }

  async init() {
    this.isMultiple = this.multiple === "" || this.multiple === true;
    this.filter = "";
    if (this.value && !this.isMultiple) {
      for (let i = 0; i < this.tags.length; i++) {
        if (this.tages[i]._id === this.value) {
          this.tag = this.tags[i];
          this.$emit("input", this.tag._id);
          break;
        }
      }
    } else {
      this.tag = [];
      if (this.value != null && Array.isArray(this.value)) {
        for (let i = 0; i < this.tags.length; i++) {
          if (this.value.filter((e) => e === this.tags[i]._id).length > 0) {
            this.tag.push(this.tags[i]);
          }
        }
      }
    }
  }

  async mounted() {
    await this.init();
    this.onKindChange(this.kind);
  }

  selected(val) {
    if (val != null && val._id != null && this.tag != null) {
      if (Array.isArray(this.tag)) {
        for (let i = 0; i < this.tag.length; i++) {
          if (val._id === this.tag[i]._id) {
            return true;
          }
        }
      } else if (this.tag != null && this.tag._id != undefined) {
        if (val._id === this.tag._id) {
          return true;
        }
      }
    }
    return false;
  }
}
</script>

<style scoped>
.filterBox {
  position: sticky;
  background: white;
  top: 0;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-bottom: 1px solid #dfdfdf;
}

.v-select-list {
  padding: 0;
}
.menuable__content__active,
.v-menu__content {
  background: white;
}
.v-select__selections {
  height: 32px;
}
.height32 {
  height: 32px;
}
.text-title {
  min-width: 100px;
  float: left;
  margin: 4px 0;
  line-height: 1.2;
  font-weight: 400;
  font-size: 14px;
}

.actionBox {
  position: sticky;
  background: white;
  bottom: 0px;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-top: 1px solid #dfdfdf;
  padding: 10px;
}
</style>
